
import React from 'react'
import { Route, Redirect } from 'react-router-dom'
import { getBSRSToken, getIsIntegration } from './'
import { addTargetUrl } from 'Lib'

const Auth = {
	isAuthenticated: () => {
		const bsrsToken = getBSRSToken()
		// const serviceToken = getAccessToken()
		return !!bsrsToken /*&& !!serviceToken*/
	},
	isIntegration: () => {
		// const o365Token = getO365Token()
		const isIntegration = getIsIntegration()
		let setIsIntegration = typeof isIntegration === 'boolean' ? isIntegration : false
		if (typeof isIntegration === 'string' && isIntegration.toLowerCase() === 'true') {
			setIsIntegration = true
		}

		if (typeof setIsIntegration === 'boolean') {
			return setIsIntegration
		}

		return !!setIsIntegration
	}
}

const PrivateRoute = ({ component: Component, ...rest }) => (
	<Route onUpdate={() => window.scrollTo(0, 0)} {...rest} render={(props) => {
		if (Auth.isAuthenticated() === false && props.match.url !== "/login") {

			const { match } = props
			let path = ''
			if (match && match.url && typeof match.url === 'string') {
				path = match.url
			}

			addTargetUrl(path)
			
			return <Redirect to={`/login`} />
		}

		if (
			Auth.isIntegration() === false
			&& (
				props.match.url !== "/integrationInfo"
				&& props.match.url !== "/google/authencallback"
				&& props.match.url !== "/integration/exchange"
			)
		) {
			return <Redirect to='/integrationInfo' />
		}

		if (Component !== undefined) {
			return <Component {...props} />
		} else {
			return <Redirect to='/' />
		}
	}} />
)

const PublicRoute = ({ component: Component, ...rest }) => {
	return <Route onUpdate={() => window.scrollTo(0, 0)} {...rest} render={(props) => {
		// if (Auth.isAuthenticated() === true && Auth.isIntegration() === false && props.match.url !== "/integration") {
		// console.log('PublicRoute /integration')
		// return <Redirect to='/integration' />
		// }

		if (Auth.isAuthenticated() === true && props.match.url === "/login") {
			return <Redirect to='/' />
		}

		if (Component !== undefined) {
			return <Component {...props} />
		} else {
			return ""
		}
	}} />
}

export {
	PrivateRoute,
	PublicRoute,
	Auth,
}


// WEBPACK FOOTER //
// ./src/lib/routePermission.js